


















































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { Policy } from '@/modules/Policy/interfaces/policy'
import AppQueries from '@/mixins/queries'
import FoldingCard from '@/components/FoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import AppDialog from '@/components/AppDialog.vue'
import S3Handler from '@/mixins/s3'
import { translateInsuredRelatioKey } from '@/utils/translate'
import VehicleDialog from '@/modules/Vehicle/scripts/vehicle-dialog'
import InsuredDialog from '@/modules/Insured/scripts/insured-dialog'
import PropertyDialog from '@/modules/Property/scripts/property-dialog'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'
import { showOwnershipLabel } from '@/modules/Vehicle/helpers/vehicle-ownership-options'
import { showUseageLabel } from '@/modules/Vehicle/helpers/vehicle-useage-options'

@Component({
  components: {
    FoldingCard,
    AppFileUploader,
    AppDialog,
    AppAttachmentsCard
  }
})
export default class PolicyDetailRelated extends mixins(AppQueries, S3Handler, VehicleDialog, InsuredDialog, PropertyDialog) {
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy

  get attachmentList () {
    return this.policy.attachments || []
  }

  dateTimeToDisplay = dateTimeToDisplay
  showOwnershipLabel = showOwnershipLabel
  showUseageLabel = showUseageLabel
  propertyTableColumn = [
    { field: 'address',
      title: 'Address',
      slots: { default: 'address_default' },
      resizable: true
    },
    { field: 'city',
      title: 'City',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.city || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'state',
      title: 'State',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.state || '-')
        ]
      }
      }
    }
  ]

  insuredTableColumn = [
    { field: 'name',
      title: 'Insured Name',
      slots: { default: 'insured_name_default' },
      resizable: true
    },
    { field: 'relationShip',
      title: 'Relationship',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.relationShip ? translateInsuredRelatioKey(row.relationShip) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'dateOfBirth',
      title: 'Date Of Birth',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.dateOfBirth ? dateToDisplay(+row.dateOfBirth) : '-')
        ]
      }
      }
    }
  ]

  vehicleTableColumn = [
    { field: 'name',
      title: 'Vehicle Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'vin',
      title: 'VIN',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.vin)
        ]
      }
      },
      resizable: true
    },
    { field: 'ownership',
      title: 'Ownership',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', showOwnershipLabel(row.ownership))
        ]
      }
      }
    },
    { field: 'useage',
      title: 'Useage',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', showUseageLabel(row.useage))
        ]
      }
      },
      resizable: true
    },
    { field: 'year',
      title: 'Year',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.year)
        ]
      }
      },
      resizable: true
    },
    { field: 'model',
      title: 'Model',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.model)
        ]
      }
      }
    }
  ]

  get showAuto () {
    if (!this.policy) {
      return false
    }
    const { name } = this.policy.recordType

    return name.indexOf('Auto') !== -1
  }

  get vehicles () {
    if (!this.policy) {
      return []
    }

    return this.showAuto
      ? this.policy.vehicles
      : []
  }

  get insureds () {
    if (!this.policy) {
      return []
    }

    return this.policy.insureds
  }

  get properties () {
    if (!this.policy) {
      return []
    }

    return this.policy.properties
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  routeToList (routeName: string) {
    this.$router.push({
      name: routeName,
      params: {
        policyId: this.policy.id + ''
      }
    })
  }

  routeToPropertyDetail (item: any) {
    this.$router.push({
      name: 'PropertyDetailDetail',
      params: { id: item.id + '' }
    })
  }

  routeToInsuredDetail (item: any) {
    this.$router.push({
      name: 'InsuredDetailDetail',
      params: { id: item.id + '' }
    })
  }

  routeToVehicleDetail (item: any) {
    this.$router.push({
      name: 'VehicleDetailDetail',
      params: { id: item.id + '' }
    })
  }

  newVehicle (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showVehicleEditDialog(e)
  }

  newInsured (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showInsuredEditDialog(e)
  }

  newProperty (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showPropEditDialog(e)
  }

  clearForm () {
    this.hideVehicleEditDialog()
    this.hideInsuredEditDialog()
    this.hidePropEditDialog()
  }
}
